import React, { useRef, useEffect } from 'react';
import { useRestaurantContext } from '../../../context/RestaurantContext';

const CategoryTabs = ({ categories, selectedCategory, onSelectCategory }) => {
  const { theme } = useRestaurantContext();
  const scrollRef = useRef(null);

  // Auto-scroll the active tab to the center when selectedCategory changes
  useEffect(() => {
    if (!scrollRef.current) return;
    const activeTab = document.getElementById(`tab-${selectedCategory.replace(/\s+/g, '-')}`);
    if (activeTab) {
      const container = scrollRef.current;
      const scrollLeft = activeTab.offsetLeft - (container.clientWidth / 2) + (activeTab.clientWidth / 2);
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }, [selectedCategory]);

  return (
    <div className="flex justify-center">
      <div
        ref={scrollRef}
        className="flex space-x-2.5 overflow-x-auto p-1.5 rounded-full [&::-webkit-scrollbar]:hidden scroll-smooth"
      >
        {categories.map((category) => (
          <button
            key={category}
            id={`tab-${category.replace(/\s+/g, '-')}`}
            onClick={() => onSelectCategory(category)}
            className={`px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 ease-in-out whitespace-nowrap border border-gray-300 flex-shrink-0 ${
              selectedCategory === category ? 'text-white' : 'hover:bg-gray-200'
            }`}
            style={{
              backgroundColor:
                selectedCategory === category
                  ? theme?.secondary || '#000'
                  : 'transparent',
              color:
                selectedCategory === category
                  ? theme?.primary || '#fff'
                  : 'black',
            }}
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryTabs;
